<template>
    <div class="usedex">
        <div class="usedex_title"> 二手机设备查询 </div>
        <div class="usedex_desc">设备序列号：</div>
        <div class="usedex_ipt"><input type="text" v-model="methednum" placeholder="请输入设备序列号"></div>
        <div style="display: grid;place-items: center;"><div class="usedex_btn" @click="getusederclick"><span style="margin-right: 15px;">查</span><span>询</span></div></div>
        <div style="margin-top: 30px;">
            <div class="body-ul" >
                <div class="body-ul-t">设备序列号:</div>
                <div class="body-ul-d">{{ getusederlist.serialnum }}</div>
            </div>
            <div class="body-ul">
                <div class="body-ul-t">设备型号:</div>
                <div class="body-ul-d">{{ getusederlist.modelnum }}</div>
            </div>
            <div class="body-ul">
                <div class="body-ul-t">设备小时数:</div>
                <div class="body-ul-d">{{ getusederlist.hours }}</div>
            </div>
            <div class="body-ul">
                <div class="body-ul-t">设备年限:</div>
                <div class="body-ul-d">{{ getusederlist.year }}</div>
            </div>
            <div class="body-ul">
                <div class="body-ul-t">设备价格:</div>
                <div class="body-ul-d">{{ getusederlist.price }}</div>
            </div>
        </div>
    </div>
</template>

<script >

import { esjAPI } from '../../api/usedexcavator.js';
import { Dialog } from 'vant';
export default{
    data(){
        return{
            methednum:'',
            getusederlist:{},
        }
    },
    mounted(){
        
    },
    methods:{
        getusederclick(){
           
            this.$axios.post(esjAPI.QwEquipmentindex, {
                serialnum:this.methednum
            })
                .then((res) => {
                    console.log(res)
                    this.showloading = false
                    if (res.data.code == 1) {
                        if(res.data.data.length==0){
                            this.getusederlist=[];
                            Dialog.alert({
                            title: '提示',
                            message: '设备不存在',
                        })
                        }else{
                            this.getusederlist = res.data.data[0]
                        }
                       
                    }else{
                        Dialog.alert({
                            title: '提示',
                            message: res.data.msg,
                        })
                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        }
        
    }
}
</script>

<style  scoped>
    .usedex{
        font-size: 16px;
        width: 100%;
        padding: 40px;
        color: #000;
    }
    .usedex_title{
        font-size: 20px;
        font-weight: bold;
        color: #000;
    }
    .usedex_desc{
        margin: 20px 0;
        font-weight: bold;
    }
    .usedex_ipt{
        height: 40px;
        border: 1px solid #bbb;
        padding-left:10px ;
        margin-bottom:20px ;
    }
    .usedex_ipt input{
        border: 0;
        height: 40px;
        width: 100%;
        font-size: 14px;
    }
    .usedex_btn{
        background-color: #56C0FE;
        color: #fff;
        height: 40px;
        width: 140px;
        border-radius: 5px;
        font-size: 18px;
        font-weight: bold;
        /* text-align: center;
        line-height: 40px; */
        display: flex;
  align-items: center;
  justify-content: center;
    
    }
    .body-ul{
        display: flex;
        margin-top: 15px;
    }
    .body-ul-t{
        flex: 1;
    }
    .body-ul-d{
        flex: 2;
    }
</style>


// WEBPACK FOOTER //
// src/pages/usedexcavator/index.vue